<script>
  import { Scrollbar } from 'element-ui'
  export default {
    name:"ElScrollbar",
    extends:Scrollbar
  }
</script>
